import { render, staticRenderFns } from "./loginDetails.vue?vue&type=template&id=2c7494ac&"
import script from "./loginDetails.vue?vue&type=script&lang=js&"
export * from "./loginDetails.vue?vue&type=script&lang=js&"
import style0 from "./loginDetails.vue?vue&type=style&index=0&id=2c7494ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports